import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { encryptURLParam, decryptURLParam } from "../../Common/Axios/encrypt";
import getTranslationData from "../../TranslationUtility/TranslationUtility";

const DiscountFilterNew = ({ product, discount, setMaxDiscount, setPageNumber, maxDiscountValue, categoryName }) => {
  const translation = getTranslationData();
  const [selectedRanges, setSelectedRanges] = useState([]); // array of selected range keys
  const navigate = useNavigate();
  const location = useLocation();

  // Fixed ordered slabs with numeric ids required in payload
  const SLABS = [
    { key: "0-5", label: translation?.discount_slab1 || "0 to 5%", value: 1 },
    { key: "5-10", label: translation?.discount_slab2 || "5 to 10%", value: 2 },
    { key: "10+", label: translation?.discount_slab3 || "Above 10%", value: 3 },
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const enc = params.get("discountSlab"); // <-- new param name (numeric ids)
    if (enc) {
      const dec = process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false' ? enc : decryptURLParam(enc);
      // dec expected as "1,2" etc -> map back to keys for checked UI
      const tokens = String(dec).split(",").map(t => t.trim()).filter(Boolean);
      const keys = tokens.map(tok => SLABS.find(s => String(s.value) === tok)?.key).filter(Boolean);
      setSelectedRanges(keys);
      setPageNumber && setPageNumber(1);
      if (typeof discount === "function") {
        discount(tokens.length ? tokens.join(",") : null); // pass numeric slab ids to parent
      }
    } else {
      setSelectedRanges([]);
      discount && discount(null);
    }
  }, [location.search]);

  const toggleRange = (rangeKey) => {
    const next = selectedRanges.includes(rangeKey)
      ? selectedRanges.filter(k => k !== rangeKey)
      : [...selectedRanges, rangeKey];

    const ordered = SLABS.map(s => s.key).filter(k => next.includes(k));
    setSelectedRanges(ordered);

    const params = new URLSearchParams(location.search);
    if (ordered.length) {
      // send numeric slab ids in URL and payload
      const payloadValues = ordered.map(key => SLABS.find(s => s.key === key)?.value).filter(Boolean);
      const finalPayload = payloadValues.join(",");
      const finalVal = process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false' ? finalPayload : encryptURLParam(finalPayload);
      params.set("discountSlab", finalVal); // <-- new param name
      if (typeof discount === "function") {
        discount(finalPayload);
      }
    } else {
      params.delete("discountSlab");
      discount && discount(null);
    }
    setPageNumber && setPageNumber(1);
    navigate(`${location.pathname}?${params.toString()}`, { replace: false });
  };

  return (
    <div className="sidefilboxlist">
      <div className="filterdrpbtn">
        <span>{translation?.discount}</span>
      </div>
      <div id="categorufil2" className="filterinner collapse show" data-parent="#otherfilter">
        <div className="checklistfilter">
          <div>
            <fieldset className="form-group1">
              <div className="filter-container">
                {SLABS.map((s) => (
                  <div key={s.key} className="rangeSlider d-flex filter-container">
                    <label className="checkbox-container">
                      <input
                        id={s.label}
                        className="filter_category_checkbox"
                        type="checkbox"
                        checked={selectedRanges.includes(s.key)}
                        onChange={() => toggleRange(s.key)}
                      />
                      <label className="pointer" htmlFor={s.label}>{s.label}</label>
                    </label>
                  </div>
                ))}
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountFilterNew;
